import React from "react";
import Header from "../../components/Header";
import ServiceRow from "../../components/ServiceRow";
import Firebase from "../../firebasehelper";
import AddServiceModal from "./components/AddServiceModal";
import AddTier2 from "./components/AddTier2";
import "./index.css";
class Chatbot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      brand_name: "",
      brand_url: "",
      services_routing: [],
      selectedTier1: null,
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      console.log("brand", brand);
      Firebase.getBrandDataByID(brand, async (res) => {
        console.log("brand_data", res);
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          hex: res.hex,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
          services_routing: res.services_routing,
          routings: res.services_routing,
        });
        try {
          let result = await this.getServicesRouting(res.name);
          console.log("result", result);
          this.setState({ services_routing: result, loading: false });
        } catch (error) {
          this.setState({ loading: false });
          alert(error);
        }
      });
    }
  }
  getServicesRouting = async (brand_name) => {
    let services_routing = await Firebase.getServicesRouting(brand_name);
    this.setState({ services_routing });
    let promise = services_routing.map(async (item, index) => {
      let tier1 = item.tier1;
      let tier2 = item.tier2;

      if (tier2 == null) {
        let tier1_data = await Firebase.getTier1byID(tier1.id);
        let data = tier1_data;
        data["value"] = [];
        data.is_brandRouting = item.is_brandRouting;
        data.active = tier1.active;
        data.id = tier1.id;
        return data;
      } else {
        let tier1_data;
        tier1_data = await Firebase.getTier1byID(tier1.id);

        let tier2_data = await this.getTier2DatafromTier2(tier2);
        const { title, src } = tier1_data;
        let data = { title: title, src: src };
        data["value"] = tier2_data;
        data.active = tier1.active;
        data.is_brandRouting = item.is_brandRouting;
        data.id = tier1.id;
        return data;
      }
    });
    return Promise.all(promise);
  };
  getTier2DatafromTier2 = (tier2) => {
    if (tier2) {
      let tier2_promise = tier2.map(async (item) => {
        let category_data = await Firebase.getCategorybyID(item.id);
        console.log("tier2", tier2);
        const { topic, image } = category_data;
        if (item.id === 0)
          return {
            id: 0,
            title: "Home Emergency",
            src: image,
            active: item.active,
          };
        else if (item.id === 1)
          return {
            id: 1,
            title: "Home Repairs",
            src: image,
            active: item.active,
          };
        else
          return { id: item.id, title: topic, src: image, active: item.active };
      });
      return Promise.all(tier2_promise);
    }
  };

  toggleTier1 = (index) => {
    this.setState({ selectedTier1: index });
  };

  toggleTier2 = (tier1_index, tier2_index) => {
    let { services_routing } = this.state;
    let active = services_routing[tier1_index].value[tier2_index].active;
    services_routing[tier1_index].value[tier2_index].active = !active;
    console.log("services_routing", services_routing);
    this.setState({ services_routing });
    this.save();
  };

  showServicesRouting = () => {
    const { services_routing } = this.state;
    console.log("services_routing in showServicesRouting", services_routing);
    return services_routing.map((item, index) => {
      const { is_brandRouting, active } = item;
      return (
        <div className="service-chatbot">
          {!is_brandRouting && (
            <button
              className={active ? "active" : "deactive"}
              style={{
                backgroundImage: `url(${item.src})`,
              }}
              onClick={() => this.toggleTier1(index)}
            ></button>
          )}
          {is_brandRouting && (
            <button
              className={`branded_button ${active ? "active" : "deactive"}`}
              id={index}
              onClick={() => this.toggleTier1(index)}
            >
              <img src={item.src} alt="brand" />
              <p>{item.title}</p>
            </button>
          )}
        </div>
      );
    });
  };

  showTier2data = () => {
    const { services_routing, selectedTier1 } = this.state;
    if (selectedTier1 === null) return;
    const service = services_routing[selectedTier1];
    if (!service.value) return;
    const { is_brandRouting } = service;

    return (
      <React.Fragment>
        <h4>Personal Assistant Service Routings</h4>
        <div className="services-content-chatbot">
          {service.value.map((item, index) => {
            const active = item.active;
            return (
              <div className="service-chatbot">
                {!is_brandRouting && (
                  <button
                    className={`${active ? "active" : "deactive"}`}
                    id={index}
                    onClick={() => this.toggleTier2(selectedTier1, index)}
                    style={{
                      backgroundImage: `url(${item.src})`,
                    }}
                  ></button>
                )}
                {is_brandRouting && (
                  <button
                    className={`branded_button ${
                      active ? "active" : "deactive"
                    }`}
                    id={index}
                    onClick={() => this.toggleTier2(selectedTier1, index)}
                  >
                    <img src={item.src} alt="brand" />
                    <p>{item.title}</p>
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  };

  save = () => {
    this.setState({ loading: true });
    let { services_routing, brand } = this.state;
    console.log("pre services_routing", services_routing);
    services_routing = services_routing.map((item) => {
      let new_item = { tier1: {}, tier2: {} };
      if (item.is_brandRouting) new_item.is_brandRouting = item.is_brandRouting;
      new_item.tier1.active = item.active;
      new_item.tier1.id = item.id;

      let tier2 = item.value;
      tier2 = tier2.map((tier) => {
        let newtier2 = {};
        newtier2.id = tier.id;
        newtier2.active = tier.active;
        return newtier2;
      });
      new_item.tier2 = tier2;
      return new_item;
    });
    console.log("services_routing", services_routing);
    Firebase.updateBrandDataById(brand, { services_routing: services_routing });
  };
  addService = async (
    tier1_img_url,
    tier2_img_url,
    tier1_title,
    tier2_title,
    site_url
  ) => {
    const { brand, routings } = this.state;
    console.log("service_routing in add Service", routings);
    let new_servicerouting = routings;
    Firebase.addTier1(tier1_img_url, tier1_title).then((res) => {
      let tier1_id = res;
      Firebase.addNewCategory(tier2_img_url, tier2_title, site_url).then(
        (result) => {
          let category_id = result;
          const newObj = {
            tier1: { active: true, id: tier1_id },
            tier2: [{ active: true, id: category_id }],
            is_brandRouting: true,
          };
          new_servicerouting.push(newObj);
          console.log("new_servicerouting", new_servicerouting);
          Firebase.updateBrandDataById(brand, {
            services_routing: new_servicerouting,
          });
        }
      );
      console.log("Tier1 id added", res);
    });
  };
  addTier2 = async (tier2_img_url, tier2_title, site_url) => {
    const { brand, routings, selectedIndex } = this.state;
    let new_servicerouting = routings;
    console.log("selectedIndex", selectedIndex);
    Firebase.addNewCategory(tier2_img_url, tier2_title, site_url).then(
      (result) => {
        let category_id = result;
        const newObj = { active: true, id: category_id };
        new_servicerouting[selectedIndex].tier2.push(newObj);
        console.log("new_servicerouting", new_servicerouting);
        Firebase.updateBrandDataById(brand, {
          services_routing: new_servicerouting,
        });
      }
    );
  };
  render() {
    const {
      username,
      role,
      logo,
      brand,
      brand_name,
      loading,
      is_property_brand,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="services-content-chatbot">
            {!loading ? (
              this.showServicesRouting()
            ) : (
              <div className="loading-bar">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
          </div>
          {this.showTier2data()}
          <AddServiceModal addService={this.addService} />
          <AddTier2 addService={this.addTier2} />
        </main>
      </div>
    );
  }
}
export default Chatbot;



// WEBPACK FOOTER //
// ./src/screens/Chatbot/index.js